export default __webpack_public_path__ + "static/media/6113 - CDY.29fbcf85.jpeg";